
import React, { Component } from 'react';
import './styles/player-controls-empty.css';
import TimeLabel from './common/TimeLabel';
import PlayerSlider from './common/PlayerSlider';
import VideoPlayerControl from './../components/common/VideoPlayerControl';
import {
  CONTROL_BACKWARD,
  CONTROL_FORWARD,
  CONTROL_PLAY
} from './common/constants';
import Translator from '../../requests/apa/Translator';
import { Grid, Row, Column, cls } from '../../packages/components';


class PlayerControlsEmpty extends Component {

  constructor(props) {
    super(props);

    this.defaultButtons = [
      { type: CONTROL_BACKWARD, clic: () => {}, enabled: false, title: Translator.get('playing_playerControls_toolbar_button_rewind', 'Atrasar')},
      { type: CONTROL_PLAY, clic: () => {}, enabled: false, title: Translator.get('playing_playerControls_toolbar_button_play', 'Reproducir'), ref: null },
      { type: CONTROL_FORWARD, clic: () => {}, enabled: false, title: Translator.get('playing_playerControls_toolbar_button_forward', 'Adelantar') }
    ];
  }

  addEventListeners() {
    this.removeEventListeners();
  }

  removeEventListeners() {
  }

  componentDidMount() {
    this.addEventListeners();
  }

  getVisibleButtons() {
    return this.defaultButtons;
  }

  updateCurrentTime(currentTime) {
  }

  render() {

    const visibleButtons = this.getVisibleButtons();

    let defLength = 3;
    let controlsClassName = '';
    if(Array.isArray(visibleButtons)) {
      defLength = visibleButtons.length;
      controlsClassName = `player-controls-width-${defLength}`;
    }

    return (
      <div>
        <Grid className="player-controls-empty-container">
          <Row className="player-controls-empty-flex-slider-wrapper">
            <Column lg={1} className={cls(``)}>
              <TimeLabel time="00:00:00" />
            </Column>
            <Column lg={10} className={cls(``)}>
              {/* La barra Bar Total es la que muestra en un startover, la que muestra el progress del evento respecto al now.  */}
              <PlayerSlider
                withBarTotal={false}
                onSlide={null}
              />
            </Column>
            <Column lg={1} className={cls(``)}>
              <TimeLabel time="--:--:--" />
            </Column>
          </Row>

          <Row className={cls(``)}>
            <div className="player-controls-empty-separator"></div>
          </Row>

                </Grid>
                <Grid className={cls(`player-controls-empty-no-grid-float`)}>
                    <Row className={cls(`player-controls-empty-flex-controls-wrapper ${controlsClassName}`)}>
                        {
                            visibleButtons.map((button, idx, items) => <VideoPlayerControl
                                control={button}
                                onClic={button.clic}
                                key={idx}
                                nav={this.props.getPlayerControlsButtonNavigation(idx, items, true)}
                            />
                            )
                        }
                    </Row>
                </Grid>
            </div>
        )
    }
}

export default PlayerControlsEmpty;



// WEBPACK FOOTER //
// ./src/playerDomain/components/PlayerControlsEmpty.js